'use strict';

var protons = require('protons');

var pb = protons(require('./unixfs.proto')); // encode/decode

var unixfsData = pb.Data; // const unixfsMetadata = pb.MetaData // encode/decode

var types = ['raw', 'directory', 'file', 'metadata', 'symlink', 'hamt-sharded-directory'];
var dirTypes = ['directory', 'hamt-sharded-directory'];

function Data(type, data) {
  var _this = this;

  if (!(this instanceof Data)) {
    return new Data(type, data);
  }

  if (types.indexOf(type) === -1) {
    throw new Error('Type: ' + type + ' is not valid');
  }

  this.type = type;
  this.data = data;
  this.blockSizes = [];

  this.addBlockSize = function (size) {
    _this.blockSizes.push(size);
  };

  this.removeBlockSize = function (index) {
    _this.blockSizes.splice(index, 1);
  }; // data.length + blockSizes


  this.fileSize = function () {
    if (dirTypes.indexOf(_this.type) >= 0) {
      // dirs don't have file size
      return undefined;
    }

    var sum = 0;

    _this.blockSizes.forEach(function (size) {
      sum += size;
    });

    if (data) {
      sum += data.length;
    }

    return sum;
  }; // encode to protobuf


  this.marshal = function () {
    var type;

    switch (_this.type) {
      case 'raw':
        type = unixfsData.DataType.Raw;
        break;

      case 'directory':
        type = unixfsData.DataType.Directory;
        break;

      case 'file':
        type = unixfsData.DataType.File;
        break;

      case 'metadata':
        type = unixfsData.DataType.Metadata;
        break;

      case 'symlink':
        type = unixfsData.DataType.Symlink;
        break;

      case 'hamt-sharded-directory':
        type = unixfsData.DataType.HAMTShard;
        break;

      default:
        throw new Error("Unkown type: \"".concat(_this.type, "\""));
    }

    var fileSize = _this.fileSize();

    var data = _this.data;

    if (!_this.data || !_this.data.length) {
      data = undefined;
    }

    var blockSizes = _this.blockSizes;

    if (!_this.blockSizes || !_this.blockSizes.length) {
      blockSizes = undefined;
    }

    return unixfsData.encode({
      Type: type,
      Data: data,
      filesize: fileSize,
      blocksizes: blockSizes,
      hashType: _this.hashType,
      fanout: _this.fanout
    });
  };
} // decode from protobuf https://github.com/ipfs/go-ipfs/blob/master/unixfs/format.go#L24


Data.unmarshal = function (marsheled) {
  var decoded = unixfsData.decode(marsheled);

  if (!decoded.Data) {
    decoded.Data = undefined;
  }

  var obj = new Data(types[decoded.Type], decoded.Data);
  obj.blockSizes = decoded.blocksizes;
  return obj;
};

exports = module.exports = Data;